import {Component, OnDestroy, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {
  ColDef,
  ColumnApi, GetContextMenuItemsParams,
  GridApi,
  GridReadyEvent,
  IServerSideGetRowsParams, RowClassRules, RowNode, SetFilterValuesFuncParams,
  ValueFormatterParams
} from 'ag-grid-community';
import {Observable} from 'rxjs';
import {ConfirmationCellComponent} from '../components/confirmation-cell/confirmation-cell.component';
import { StorageService } from 'src/app/services/storage.service';
import {GridService} from '../../services/grid.service';
import {HttpService} from '../../services/http.service';
import {CellEditorTagsComponent} from '../cell-editors/cell-editor-tags/cell-editor-tags.component';
import {SharedService} from '../../services/shared.service';
import {HistoryDialogComponent} from '../dialogs/history-dialog/history-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {LogsToolPanelComponent} from '../components/logs-tool-panel/logs-tool-panel.component';
import {AuthService} from '../../services/auth.service';
import {shareReplay} from 'rxjs/operators';
import {AdminToolPanelComponent} from '../components/admin-tool-panel/admin-tool-panel.component';
import {LocalStorageService} from '../../services/local-storage.service';

@Component({
  selector: 'app-grid-history',
  templateUrl: './grid-history.component.html',
  styleUrls: ['./grid-history.component.scss']
})
export class GridHistoryComponent implements OnInit, OnDestroy {
  public user$: Observable<any>;
  public readonly paginationPageSize = 1000;
  public readonly cacheBlockSize = 33;
  public readonly maxBlocksInCache = 10;
  public readonly maxConcurrentDatasourceRequests = 10;
  public readonly rowModelType = 'serverSide';
  public readonly rowSelection = 'multiple';
  // public readonly rowGroupPanelShow = 'always';
  public readonly rowGroupPanelShow = 'never';
  public gridApi?: GridApi;
  public columnApi?: ColumnApi;
  private gridReady: boolean = false;

  // public defaultColDef: ColDef = this.sharedService.defaultColDef;
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 170,
    sortable: true,
    editable: false,
    filter: true,
    resizable: true,
    menuTabs: ['filterMenuTab', 'generalMenuTab'],
    filterParams: {
      buttons: ['reset'],
    },

    cellRenderer: (cell: any) => {
      if (!['tags'].includes(cell.colDef.field)) {
        return cell.value;
      }
    },
    cellClass: (params: any) => {
      const cellChanged = params.data?.fields_status?.[params.colDef.field] === 20;
      const cellLock = params.data.locked !== undefined && Object.keys(params.data.locked).length > 0;
      const cellLockOtherUsers = cellLock ? params.data.locked && params.data.locked.user && params.data.locked.user._id !== this.authService.currentUserValue?._id: false;
      const cellLockCurrentUsers = cellLock ? params.data.locked && params.data.locked.user && params.data.locked.user._id === this.authService.currentUserValue._id: false;
      const cellPrice = (params.colDef.field === 'list_price' || params.colDef.field === 'cost_price'  || params.colDef.field === 'sell_price' || params.colDef.field === 'mws_sell_price');

      if (cellPrice && cellChanged) {
        return ['number-cell', 'ag-cell-changed'];
      } else if (cellChanged) {
        if (cellLockOtherUsers) {
          return '';
        }
        return 'ag-cell-changed';
      } else if (params.colDef.field === 'sku') {
        return 'sku-col';
      } else if (cellPrice) {
        return 'number-cell';
      }

      return '';
    }
  }
  // public defaultColDef: ColDef = {
  //   resizable: true,
  //   flex: 1,
  //   minWidth: 120,
  //   sortable: true,
  //   enableRowGroup: true,
  //   // cellClass: (params: any) => {
  //   //   if (!['user_name', 'history.updatedAt'].includes(params.colDef?.field) && params.data.history[params.colDef?.field] !== null) {
  //   //     return 'ag-cell-changed';
  //   //   } else {
  //   //     return '';
  //   //   }
  //   // },
  //   cellClass: (params: any) => {
  //     // console.log('params', params);
  //     const cellChanged = (params.data?.changes?.[params.colDef.field]);
  //     const cellPrice = (params.colDef.field === 'list_price' || params.colDef.field === 'cost_price'  || params.colDef.field === 'sell_price');
  //
  //     if (cellPrice && cellChanged) {
  //       return ['number-cell', 'ag-cell-changed'];
  //     } else if (cellChanged) {
  //       return 'ag-cell-changed';
  //     } else if (params.colDef.field === 'sku') {
  //       return 'sku-col';
  //     } else if (cellPrice) {
  //       return 'number-cell';
  //     }
  //
  //     return '';
  //   },
  //   // cellRenderer: (cell: any) => {
  //   //   // console.log('🟠', cell);
  //   //   const field: any = cell.column.colId;
  //   //   if (field === 'brand') {
  //   //     if (cell.value === undefined) {
  //   //       return cell.data?.product[field]?.stage?.name;
  //   //     } else {
  //   //       return cell.value.name;
  //   //     }
  //   //   }
  //   //
  //   //   if (field === 'type') {
  //   //     if (cell.value === undefined) {
  //   //       return cell.data?.product[field]?.stage?.name;
  //   //     } else {
  //   //       return cell.value.name;
  //   //     }
  //   //   }
  //   //
  //   //   if (field === 'replacement') {
  //   //     if (cell.value === undefined) {
  //   //       if (cell.data?.product.replacement.stage?.obsolete && !cell.data.product.replacement?.stage?.sku) {
  //   //         return 'Obsolete / NO replacement';
  //   //       } else {
  //   //         return cell.data.product.replacement.stage?.sku;
  //   //       }
  //   //     } else {
  //   //       if (cell.value.obsolete && !cell.value.sku) {
  //   //         return 'Obsolete / NO replacement';
  //   //       } else {
  //   //         return cell.value.sku;
  //   //       }
  //   //     }
  //   //   }
  //   //
  //   //   if (field === 'tags') {
  //   //     if (cell.value === undefined) {
  //   //       let tags: any = [];
  //   //       cell.data.product.tags.stage.forEach((tag: any) => {
  //   //         const finder = this.storageService.tags.find(t => t._id === tag._id);
  //   //         if (finder) {
  //   //           tags.push(finder.name);
  //   //         }
  //   //       });
  //   //       return tags.join(', ');
  //   //     } else {
  //   //       let tags: any = [];
  //   //       cell.value.forEach((tag: any) => {
  //   //         const finder = this.storageService.tags.find(t => t._id === tag._id);
  //   //         if (finder) {
  //   //           tags.push(finder.name);
  //   //         }
  //   //       });
  //   //       return tags.join(', ');
  //   //     }
  //   //   }
  //   //
  //   //   if (['sell_price', 'cost_price', 'list_price'].includes(field)) {
  //   //     if (cell.value) {
  //   //       return '$' + parseFloat(cell.value).toFixed(2).toString();
  //   //     } else {
  //   //       return null;
  //   //     }
  //   //   }
  //   //
  //   //   if (['_id', 'user_name', 'history.updatedAt'].includes(field)) {
  //   //     return cell.value;
  //   //   }
  //   //
  //   //   // if (cell?.value === undefined) {
  //   //   //   return cell?.data?.product[field]?.stage
  //   //   // } else {
  //   //   //   return cell?.value;
  //   //   // }
  //   // }
  // }

  public rowClassRules: RowClassRules = {
    // 'confirm-changes': (params) => {
    //   return !!(params.data && params.data.history.accepted_status === 1);
    // },
    // 'conflict-changes': (params) => {
    //   return !!(params.data && params.data.history.accepted_status === 3);
    // },
    // 'reject-changes': (params) => {
    //   return !!(params.data && params.data.history.accepted_status === 2);
    // },
    // 'push-changes': (params) => {
    //   return !!(params.data && params.data.history.accepted_status === 4);
    // }
  }

  getContextMenuItems = (params: GetContextMenuItemsParams) => {
    let restoreValue: any = null;
    const cellId: any = params.column?.getId();
    const disableHistoryBtn = params.node?.data.logs[cellId] === false;
    return [
      {
        name: 'Open BHS Shopify Page',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://blackhawksupply.com/products/' + params?.node?.data.handle, '_blank');
        }
      },
      'separator',
      {
        name: 'Open MWS Shopify Page',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://midwestsupplyus.com/products/' + params?.node?.data.handle, '_blank');
        }
      },
      'separator',
      {
        name: 'Auto Size Column',
        icon: '<span class="ag-icon ag-icon-maximize" unselectable="on" role="presentation"></span>',
        action: () => {
          const colId: any = params.column?.getId();
          this.gridService.historyColumnApi?.autoSizeColumn(colId);
        }
      },
      {
        name: 'Pin Row',
        icon: '<span class="ag-icon ag-icon-pin" unselectable="on" role="presentation"></span>',
        action: () => {
          const colId: any = params.column?.getId();
          this.gridService.historyGridApi?.setPinnedTopRowData([params?.node?.data]);
        }
      },
      // {
      //   name: 'History',
      //   icon: '<span class="ag-icon ag-icon-group" unselectable="on" role="presentation"></span>',
      //   disabled: disableHistoryBtn,
      //   action: () => {
      //     this.dialog.open(HistoryDialogComponent, {
      //       width: '90%',
      //       maxWidth: '1024px',
      //       disableClose: true,
      //       data: {
      //         params,
      //         disableRollBack: true,
      //         sku: params.node?.data.sku,
      //         column: params.column?.getColDef().headerName,
      //         product_id: params.node?.data.product,
      //         field: params.column?.getId()
      //       }
      //     });
      //   }
      // },
      restoreValue,
    ];
  }

  public columnDefs: ColDef[] = this.sharedService.columnDefs;
  public rowData$!: Observable<any[]>;

  public readonly sideBar = {
    // defaultToolPanel: 'logsPanel',

    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
        }
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
        toolPanelParams: {
          suppressExpandAll: false,
          suppressFilterSearch: false
        }
      },
      // {
      //   id: 'logsPanel',
      //   labelDefault: 'Changes',
      //   labelKey: 'logsPanel',
      //   iconKey: '',
      //   toolPanel: LogsToolPanelComponent,
      //   width: 297,
      //   maxWidth: 297,
      // },
    ],
  };
  constructor(
    private storageService: StorageService,
    private gridService: GridService,
    private httpService: HttpService,
    private sharedService: SharedService,
    private dialog: MatDialog,
    private authService: AuthService,
    private localStorageService: LocalStorageService,
  ) {
    this.user$ = this.authService.getCurrentUser().pipe(
      shareReplay()
    );
  }

  ngOnInit(): void {
    this.user$.subscribe(res => {
      // if (res && res.access.level === 1) {
      //   const toolPanel: any = {
      //     id: 'adminPanel',
      //     labelDefault: 'Admin',
      //     labelKey: 'customStats',
      //     iconKey: 'columnMoveMove',
      //     toolPanel: AdminToolPanelComponent,
      //     width: 400,
      //     maxWidth: 400,
      //   }
      //
      //   this.sideBar.toolPanels.push(toolPanel);
      //   setTimeout(() => {
      //     this.gridService.historyGridApi?.refreshToolPanel();
      //     this.gridService.historyGridApi?.setSideBar(this.sideBar);
      //   }, 500);
      // }
    });
    const confirmationRow = this.columnDefs.find(x => x.field === 'confirm');
    const changeByUserRow = this.columnDefs.find(x => x.field === 'changed_by');
    const pushedAtRow = this.columnDefs.find(x => x.field === 'pushed_at');
    const pushedUserRow = this.columnDefs.find(x => x.field === 'pushed_user');
    const skuRow = this.columnDefs.find(x => x.field === 'sku');
    const updatedAtRow = this.columnDefs.find(x => x.field === 'updated_at');
    const statusRow = this.columnDefs.find(x => x.field === 'status');
    const update_method = this.columnDefs.find(x => x.field === 'update_method');

    if (update_method) {
      update_method.hide = false;
    }

    if (statusRow) {
      statusRow.hide = true;
    }

    if (updatedAtRow) {
      updatedAtRow.hide = true;
      updatedAtRow.sortable = false;
      updatedAtRow.suppressFiltersToolPanel = true;
      updatedAtRow.suppressColumnsToolPanel = true;
    }

    if (changeByUserRow) {
      changeByUserRow.hide = true;
      changeByUserRow.sortable = false;
      changeByUserRow.suppressFiltersToolPanel = true;
      changeByUserRow.suppressColumnsToolPanel = true;
    }

    if (skuRow) {
      skuRow.pinned = 'left';
      skuRow.sort = null;
      skuRow.checkboxSelection = true;
    }

    if (confirmationRow) {
      confirmationRow.hide = true;
      confirmationRow.suppressFiltersToolPanel = true;
      confirmationRow.suppressColumnsToolPanel = true;
    }
    if (pushedAtRow) {
      pushedAtRow.hide = false;
      pushedAtRow.suppressFiltersToolPanel = false;
      pushedAtRow.suppressColumnsToolPanel = false;
      pushedAtRow.sort = 'desc';
    }
    if (pushedUserRow) {
      pushedUserRow.hide = false;
      pushedUserRow.suppressFiltersToolPanel = false;
      pushedUserRow.suppressColumnsToolPanel = false;
    }
  }

  ngOnDestroy(): void {
    this.gridService.historySelectedItemsCount$.next(0);
  }

  filterChanged($event: any): void {
    const filterModel = this.gridService.historyGridApi?.getFilterModel();
    this.gridService.historyFilterIsActive$.next(!!(filterModel && Object.keys(filterModel).length));
  }

  onSelectionChanged($event: any): void {
    const selectedRows: any = this.gridService.historyGridApi?.getSelectedRows();
    this.gridService.historySelectedItemsCount$.next(selectedRows.length);
    console.log('🤲 selectedRows', selectedRows);
  }

  columnEverythingChanged($event: any): void {
    if (this.gridReady) {
      const savedState = this.gridService.historyColumnApi?.getColumnState();
      this.localStorageService.setItem('historyColumnState', savedState);
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridService.historyGridApi = params.api;
    this.gridService.historyColumnApi = params.columnApi;
    const columnState = this.localStorageService.getItem('historyColumnState');
    params.columnApi?.applyColumnState({
      state: columnState,
      applyOrder: true
    });
    // this.gridApi = params.api;
    // this.columnApi = params.columnApi;

    const that = this;
    this.gridService.historyGridApi.setServerSideDatasource({
      getRows(params: IServerSideGetRowsParams) {
        const {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel} = params.request;

        const body = {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel};
        that.httpService.post(environment.API_PATH + '/changes/history', body).subscribe({
          next: (dataAndCount) => {
            const receivedData = dataAndCount as { rows: {}[], count: number };
            that.gridReady = true;
            params.success({
              rowData: receivedData.rows,
              rowCount: receivedData.count
            });
          },
          error: (err) => {
            console.error('Failed to load history data:', err);
            params.fail();
          }
        });
      }
    });
  }
}
